<template>
  <transition name="popup">
    <div class="popup_wrapper" :style="{ 'z-index': zIndex }" v-show="flag" data-close @click="_close">
      <div class="popup" :class="{ 'fade-in': isShow, 'fade-out': !isShow }" :style="{ width: width + 'px' }">
        <div class="head">
          <h4 class="tit">{{ title }}</h4>
          <i class="el-icon-close close" data-close></i>
        </div>
        <div class="main">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    width: {
      type: String,
      default: "500",
    },
    flag: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: String,
      default: "10000",
    },
  },
  watch: {
    // flag() {
    //     if (this.flag) {
    //         document.documentElement.style.overflow='hidden';
    //     } else {
    //         document.documentElement.style.overflow='auto';
    //     }
    // }
  },
  data() {
    return {
      isShow: true,
    };
  },
  mounted() {},
  methods: {
    _close(e) {
      const type = e.target.dataset.close;
      if (type === undefined) {
        return;
      }
      this.isShow = false;
      setTimeout(() => {
        this.isShow = true;
        this.$emit("close", false);
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}
.fade-in {
  animation: fade-in 0.3s ease;
}
.fade-out {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  animation: fade-out 0.3s ease;
}
@keyframes popup-mask-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes popup-mask-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.popup-enter {
  animation: popup-mask-fade-in 0.3s ease;
}
.popup-leave {
  animation: popup-mask-fade-out 0.1s ease forwards;
  transform: translate3d(0, -10%, 0);
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.popup-enter-active {
  animation: popup-mask-fade-in 0.3s ease;
}
.popup-leave-active {
  animation: popup-mask-fade-out 0.1s ease forwards;
  transform: translate3d(0, -10%, 0);
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.popup_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  // z-index: 3030;
  background: rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  .popup {
    position: relative;
    box-sizing: border-box;
    margin: 15vh auto 0;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.3s;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 30px;
      height: 54px;
      border-bottom: 1px solid #f3f3f3;
      h4 {
        margin: 0;
      }
      .tit {
        // color: #333;
        font-size: 16px;
        // font-weight:bold;
      }
      .close {
        color: #999;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
      }
      .el-icon-close {
        &:hover {
          color: #fe4d45;
        }
      }
    }
    .main {
      box-sizing: border-box;
      padding: 0 30px 30px;
    }
  }
}
</style>
